import React, { FC, memo } from 'react';
import { PageTitle } from 'components/Typography';
import {
  Container,
  MenuIcon,
  Heading,
  StatusButton,
  OnSection,
  OffSection,
  AvatarSection,
  Avatar,
  Status,
} from './styles';
import useConnect from './connect';
import { Props } from './types';
import DrawerStatus from './DrawerStatus';

const TopBar: FC<Props> = ({ isTablet, handleOpenMenu }) => {
  const {
    title,
    openStatus,
    handleOpenStatus,
    handleCloseStatus,
    integrationsOn,
    integrationsOff,
  } = useConnect();
  return (
    <>
      <Container>
        <Heading>
          {isTablet && <MenuIcon onClick={handleOpenMenu} />}
          <PageTitle>{title}</PageTitle>
        </Heading>

        <StatusButton onClick={handleOpenStatus}>
          {integrationsOn.length > 0 && (
            <OnSection>
              <Status status="on" />
              <AvatarSection>
                {integrationsOn.map((integration, index) => (
                  <Avatar
                    key={integration.id}
                    src={integration.image.src}
                    alt={integration.image.alt}
                    style={{ zIndex: -index }}
                  />
                ))}
              </AvatarSection>
            </OnSection>
          )}
          {integrationsOff.length > 0 && (
            <OffSection>
              <Status status="off" />
              <AvatarSection>
                {integrationsOff.map((integration, index) => (
                  <Avatar
                    key={integration.id}
                    src={integration.image.src}
                    alt={integration.image.alt}
                    style={{ zIndex: -index }}
                  />
                ))}
              </AvatarSection>
            </OffSection>
          )}
        </StatusButton>
      </Container>
      <DrawerStatus
        openStatus={openStatus}
        handleCloseStatus={handleCloseStatus}
      />
    </>
  );
};

export default memo(TopBar);
